import { AxiosError, AxiosResponse } from "axios";
import { useMutation, useQueryClient } from "react-query";
import { loggedInApiCall } from "src/api/axiosClient/userApi";

export function useDeleteIngredientLine() {
    const queryClient = useQueryClient();
    const query = useMutation<AxiosResponse, AxiosError<object, any>, number, unknown>({
        mutationFn: async (id: number) => {
            const response = await loggedInApiCall.delete("/api/ingredient_lines/" + id);
            return response;
        },
        onSuccess: () => queryClient.invalidateQueries(["allIngredientLines"]),
    });

    return query;
}
